import { useSelector } from 'react-redux';

export default ({ id, type } = {}) => {
  if (!id || !type) return {};
  return useSelector(state => state[type][id], [id, type]);
};
